import { LoadPageAction } from "../../../pillar/common/actions/LoadPageAction";
import { LoadPagePayload } from "../../../pillar/common/actions/LoadPagePayload";
import { SystemRoleType } from "../../models/SystemRoleType";

export const QUERY_AVAILABLE_ROLES_BY_TYPE = "[SecurityModule] Query Available Roles By Type";

export class QueryAvailableRolesByTypeAction implements LoadPageAction {
  readonly identifier = new Date().getTime().toString();
  readonly type: string;

  constructor(public roleType: SystemRoleType, public payload: LoadPagePayload) {
    this.type = QUERY_AVAILABLE_ROLES_BY_TYPE;
  }
}



// WEBPACK FOOTER //
// ./src/app/security/store/actions/QueryAvailableRolesByTypeAction.ts